import { render } from "./Copyright.vue?vue&type=template&id=27a79233"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"

import "./Copyright.vue?vue&type=style&index=0&id=27a79233&lang=scss"

import exportComponent from "/Users/nicorivera/Documents/NR/Sate/sate2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__